import { TransformDesignerToMemberRequest } from './../../models/ss-api/requests/transform.designer.to.member.request';
import { FileTypes, FileUploadItemArray } from './../../models/domain/file.upload.item';
import { DialogOptions } from './../../services/modal-dialogs/dialog.service';
import { NoteDetailsDialog } from './../../dialogs/note.details/note.details.dialog';
import { MobileFilesItemArray } from '../../../app/models/domain/mobile.files.item';
// ANGULAR
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';

// SERVICES
import { GlobalService } from '../../services/global.service';
import { PinService } from '../../services/pin.service';
import { DialogService } from '../../services/modal-dialogs/dialog.service';
import { ssApiService } from '../../services/ss-api.service';

import { PinAddRequest } from '../../models/ss-api/requests/pin.add.request';
import { PinTypes } from '../../models/domain/pin';
import { NoteArray, NoteChangeResult, NoteTypes } from '../../models/domain/note';
import { GISUsageLogArray } from '../../models/domain/gis.usage.log';
import { GISBundleLogArray } from '../../models/domain/gis.bundle.log.item';
import { BreadCrumb } from '../../models/BreadCrumb';
import { BaseResponse, IBaseResponse } from '../../models/comm-http/responses/BaseResponse';

import { MemberManager } from '../../managers/member.manager';

// SHARED
import { xToastr, ToastrTypes } from '../../shared/Toastr';
import { SweetAlertService } from 'ng2-cli-sweetalert2';

import { CreditCardListComponent } from '../components/credit.card.list/credit.card.list.component';
import { ProfileOverviewComponent } from '../components/profile.overview/profile.overview.component';
import { MemberNotesComponent } from '../components/member.notes/member.notes.component';
import { TOSComponent } from '../components/tos/tos.component';

import { Subscription } from 'rxjs';
import { MemberDashboard } from '../../models/ss-api/responses/member.dashboard.response';
import { MemberDashboardLicenseResponse, MemberDashboardLicenseResponseArray, sortDirection } from '../../models/ss-api/responses/member.dashboard.license.response';
import { InvoiceArray } from '../../models/domain/invoice';
import { EmailLogItemBasicArray } from '../../models/domain/email.log.item.basics';
import { CreditItemArray } from '../../models/domain/credit.item';
import { MergeProfilesDialog } from '../../dialogs/merge.profiles/merge.profiles.dialog';
import { CustomTicketItemArray } from '../../models/domain/custom.ticket.item';
import { MemberTagsEditRequest } from '../../models/ss-api/requests/tag.edit.request';
import { TagArray, TagTOSTypes } from '../../models/domain/tag';
import { MemberNewLoginSessionRequest } from '../../models/ss-api/requests/member.new.login.session';
import { UnlockLoginRequest } from '../../models/ss-api/requests/unlock.login.request';
import { MemberEventsService } from '../../services/member.events.service';
import { UserRolesService } from '../../services/user.roles.service';
import { AdminLogItemArray } from '../../models/domain/admin.log.item';
import { LogsResponse } from '../../models/ss-api/responses/logs.response';
import { AddNotePromptDialog } from '../../dialogs/add.note.prompt/add.note.prompt.dialog';
import { MemberLogItemArray } from '../../models/domain/member.log.item';
import { WindowSettings } from '../../../app/services/window-dialogs/window.settings';
import { WindowService } from '../../../app/services/window-dialogs/window.service';
import { WindowTypes, WindowActionTypes } from '../../../app/services/window-dialogs/window.event';
import { ActivityItemArray } from '../../models/domain/activity.item';
import { SortBot } from '../../../app/helpers/sort';
import { TrainingHistoryResponseArray } from '../../../app/models/ss-api/responses/training.history.response';
import { TransferMemberDialog } from '../../../app/dialogs/transfer.member/transfer.member.dialog';
import { KeyValuePair } from '../../../app/models/KeyValuePair';
import { NoteManagerConstructor, NoteManager } from '../../../app/managers/note.manager';
import { ForceChildToMemberRequest } from '../../models/ss-api/requests/force.child.to.member.request';
import { DialogWindowTypes } from '../../services/modal-dialogs/dialog-types';
import { AuthenticationLogItemArray } from '@models/domain/authentication.log.item';
import { SubscribeToLicensesRequest } from '@models/ss-api/requests/subscribe.to.licenses.request';
import { LiveHubService } from '@services/livehub.service';
import { LiveHubConnectionStatuses } from '@models/domain/license';


@Component({
    selector: 'member-profile',
    templateUrl: './member.profile.component.html',
    styleUrls: ['./member.profile.component.css']
})
export class MemberProfileComponent implements OnInit, OnDestroy {

    IsBusy: boolean = true;

    NavBarTitle: string;
    NavBarCrumbs: Array<BreadCrumb> = new Array<BreadCrumb>();

    // viewchilds
    @ViewChild(MemberNotesComponent)
    private Notes: MemberNotesComponent;

    @ViewChild(ProfileOverviewComponent)
    private ProfileOverview: ProfileOverviewComponent;

    @ViewChild(CreditCardListComponent)
    CreditCards: CreditCardListComponent;

    TicketWidgets: CustomTicketItemArray;

    @ViewChild(TOSComponent)
    private TOS: TOSComponent;

    // dashboard component
    public Dashboard: MemberDashboard = new MemberDashboard();

    //Hotkey
    @HostListener('window:keydown.alt.n', ['$event'])
    addNoteHotkey(event: KeyboardEvent) {
        event.preventDefault();
        this.AddMemberNote();
    }

    //Hotkey
    @HostListener('window:keydown.alt.m', ['$event'])
    requestReviewHotKey(event: KeyboardEvent) {
        event.preventDefault();
        if (this.Dashboard.HasReviewed){
			this.sweetAlertService.swal({
				title: 'Error',
				text: 'This member has already left a review.  No need to request another.',
				type: 'error',
				showCancelButton: false,
				showCloseButton: true,
				confirmButtonText: 'OK',
				cancelButtonText: 'Cancel',
				allowOutsideClick: false,
				closeButtonTextContent: 'x',
				
			}).then(() => {}, () => {});
        }
        else{
            this.requestMemberReview();
        }
    }    

    //Hotkey
    @HostListener('window:keydown.alt.l', ['$event'])
    logInAsHotkey(event: KeyboardEvent) {
        event.preventDefault();
        this.LogInAsMemberClick();
    }
    
    //Hotkey
    @HostListener('window:keydown.alt.1', ['$event'])
    tabHotkey1(event: KeyboardEvent) {
        event.preventDefault();
        this.TabChanged({ index : 0 });
    }
    
    //Hotkey
    @HostListener('window:keydown.alt.2', ['$event'])
    tabHotkey2(event: KeyboardEvent) {
        event.preventDefault();
        this.TabChanged({ index : 1 });
    }

    //Hotkey
    @HostListener('window:keydown.alt.3', ['$event'])
    tabHotkey3(event: KeyboardEvent) {
        event.preventDefault();
        this.TabChanged({ index : 2 });
    }

    //Hotkey
    @HostListener('window:keydown.alt.4', ['$event'])
    tabHotkey4(event: KeyboardEvent) {
        event.preventDefault();
        this.TabChanged({ index : 3 });
    }

    //Hotkey
    @HostListener('window:keydown.alt.5', ['$event'])
    tabHotkey5(event: KeyboardEvent) {
        event.preventDefault();
        this.TabChanged({ index : 4 });
    }

    //Hotkey
    @HostListener('window:keydown.alt.6', ['$event'])
    tabHotkey6(event: KeyboardEvent) {
        event.preventDefault();
        this.TabChanged({ index : 5 });
    }

    //Hotkey
    @HostListener('window:keydown.alt.7', ['$event'])
    tabHotkey7(event: KeyboardEvent) {
        event.preventDefault();
        this.TabChanged({ index : 6 });
    }

    //Hotkey
    @HostListener('window:keydown.alt.8', ['$event'])
    tabHotkey8(event: KeyboardEvent) {
        event.preventDefault();
        this.TabChanged({ index : 7 });
    }

    //Hotkey
    @HostListener('window:keydown.alt.9', ['$event'])
    tabHotkey9(event: KeyboardEvent) {
        event.preventDefault();
        this.TabChanged({ index : 8 });
    }

    //Hotkey
    @HostListener('window:keydown.alt.0', ['$event'])
    tabHotkey0(event: KeyboardEvent) {
        event.preventDefault();
        this.TabChanged({ index : 9 });
    }

    // sticky
    public StickyNotes: NoteArray;

    // tab indexes
    indexACTIVE = 0;
    private indexSoftwareLicense = 0;
    private indexGIS = 1;
    private indexInvoices = 2;
    private indexCreditCards = 3;
    private indexActivity = 4;
    private indexNotes = 5;
    private indexLogs = 6;
    private indexEmail = 7;
    private indexTickets = 8;
    private indexCredit = 9;
    private indexTraining = 10;
    private indexYardFiles = 11;
    private indexOrphan = 12;
    private indexTOS = 13;

    // page
    Data: MemberDashboard = new MemberDashboard();
    MemberID: number;
    SubScribeParams: any;
    memberManagerIsBusy: boolean;

    private memberManager: MemberManager = new MemberManager();
    private memberManagerSubscription: Subscription;
    private memberReloadEmailsSubscription: Subscription;
    private connectionStatusSubscription: Subscription;
    private updateSuccessSubscription: Subscription;

    // Credit
    Credits: CreditItemArray;
    CreditAmount: number;
    CreditIsBusy: boolean = false;

    // Licenses
    OwnLicenses: MemberDashboardLicenseResponseArray;
    DesignersLicenses: MemberDashboardLicenseResponseArray;

    // GIS
    GISLifetimeSeconds: number = 10;
    GISLastLoaded: Date;
    GISUsageLog: GISUsageLogArray;
    GISBundleLog: GISBundleLogArray;
    GISUsageLogIsBusy: boolean = false;
    GISBundleLogIsBusy: boolean = false;

    // INVOICES
    Invoices: InvoiceArray = new InvoiceArray();
    InvoicesIsBusy: boolean = false;


    // ACTIVITY STREAM
    ActivityItems: ActivityItemArray;

    // TICKETS
    TicketSubscription: Subscription;

    // LOGS
    MemberLogs: LogsResponse;
    LogsIsBusy: boolean = false;

    // EMAIL
    EmailLogsIsBusy: boolean = false;
    EmailLogs: EmailLogItemBasicArray;

    // TOS
    TOSIsBusy: boolean = false;

    // TAGS STUFF
    AvailableTags: TagArray;

    // TRAINING
    TrainingHistory: TrainingHistoryResponseArray;
    IsTrainingBusy: boolean = false;

    // MEMBER FILES
    YardFiles: MobileFilesItemArray;
    UploadedFiles: FileUploadItemArray;
    UploadedLogs: FileUploadItemArray;

    TicketsIsBusy: boolean = false;
    IsFilesBusy: boolean;

    constructor(private route: ActivatedRoute,
        private api: ssApiService,
        private titleService: Title,
        private pinService: PinService,
        private gb: GlobalService,
        private dialogService: DialogService,
        private sweetAlertService: SweetAlertService,
        private memberEvents: MemberEventsService,
        public roles: UserRolesService,
        private windowService: WindowService,
        private liveHub: LiveHubService,
        private location: Location) {
    }

    ngOnInit() {
        this.gb.SetPageTitle('Member Profile');

        this.SubScribeParams = this.route.params.subscribe(params => {
            this.MemberID = +params['id'];

            // console.log("member id:", this.MemberID);
            // this.Dashboard.FirstName
            if (this.MemberID != null && this.MemberID > 0)
                this.SearchMember(<any>this.MemberID);
        });

        this.memberManagerSubscription = this.memberManager.OnIsBusyChanged.subscribe(isBusy => { this.memberManagerIsBusy = isBusy; });

        this.TicketSubscription = this.api.loadTickets().subscribe(
            () => {
                // console.log("TICKETS NEED TO BE RELOADED!");
                this.LoadTickets();
            });

        this.memberReloadEmailsSubscription = this.memberEvents.onMemberEmailsChanged.subscribe(() => {
            // console.log("please reload emails");
            this.GetEmailLogs();
        });
    }

    ngOnDestroy() {
        this.SubScribeParams.unsubscribe();
        this.memberManagerSubscription.unsubscribe();
        this.TicketSubscription.unsubscribe();
        this.memberReloadEmailsSubscription.unsubscribe();
        this.connectionStatusSubscription.unsubscribe();
    }

    requestMemberReview(){
        this.IsBusy = true;

        let request = new UnlockLoginRequest();
        request.MemberID = this.Dashboard.ID;

        this.sweetAlertService.swal(
            {
                title: 'Request Member Review',
                text: 'Are you sure you want to request a review from this member?  They will be emailed a link.',
                type: 'warning',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'Cancel',
                allowOutsideClick: false,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return this.api.MemberRequestReview(this.Dashboard.ID).toPromise();
                }
            })
            .then(response => {
                this.IsBusy = false;
                if (response.Result) {

                    this.sweetAlertService.swal(
                        {
                            title: 'Success!',
                            text: 'Review Request Sent',
                            type: 'success',
                            showCancelButton: false,
                            showConfirmButton: false,
                            timer: 1500
                        })
                        .then((response: any) => {
                            this.IsBusy = false;

                        }, () => {
                            this.IsBusy = false;
                            return;
                        }); // keep this line to prevent promise error;
                } else {
                    this.sweetAlertService.swal(
                        {
                            title: 'Error',
                            text: response.Message,
                            type: 'error',
                            showCancelButton: false,
                            showConfirmButton: true,
                            confirmButtonText: 'OK',
                        })
                        .then(() => {
                            this.IsBusy = false;
                            return;
                        }, () => {
                            this.IsBusy = false;
                            return;
                        }); // keep this line to prevent promise error;
                }
            }, () => {
                this.IsBusy = false;
                // this.IsBusy = false;
                return;
            })
            .catch(error => {
                this.sweetAlertService.swal(
                    {
                        title: 'Error',
                        text: error.message,
                        type: 'error',
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                    })
                    .then(() => {
                        this.IsBusy = false;
                        return;
                    }, () => {
                        this.IsBusy = false;
                        return;
                    }); // keep this line to prevent promise error;
            });
    }

    GenerateAISummary(){
        this.IsBusy = true;

        let disposable = this.api.AISummarizeActivity(this.MemberID).subscribe(result => {
            disposable.unsubscribe();
            this.IsBusy = false;
            this.Dashboard.AIActivitySummaryUpdated = new Date();
            this.Dashboard.AIActivitySummary = result.Data.ActivitySummary;
        });

    }

    unlockLogin() {
        this.IsBusy = true;

        let request = new UnlockLoginRequest();
        request.MemberID = this.Dashboard.ID;

        this.sweetAlertService.swal(
            {
                title: 'Unlock Login',
                text: 'Are you sure you want to unlock the login for member ' + this.Dashboard.FirstName + ' ' + this.Dashboard.LastName,
                type: 'warning',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Yes, unlock!',
                cancelButtonText: 'Cancel',
                allowOutsideClick: false,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return this.api.MemberUnlockLogin(request).toPromise();
                }
            })
            .then(response => {
                this.IsBusy = false;
                if (response.Result) {

                    this.Dashboard.IsLocked = false;

                    this.sweetAlertService.swal(
                        {
                            title: 'Success!',
                            text: 'Login unlocked',
                            type: 'success',
                            showCancelButton: false,
                            showConfirmButton: false,
                            timer: 1500
                        })
                        .then((response: any) => {
                            this.IsBusy = false;

                        }, () => {
                            this.IsBusy = false;
                            return;
                        }); // keep this line to prevent promise error;
                } else {
                    this.sweetAlertService.swal(
                        {
                            title: 'Error',
                            text: response.Message,
                            type: 'error',
                            showCancelButton: false,
                            showConfirmButton: true,
                            confirmButtonText: 'OK',
                        })
                        .then(() => {
                            this.IsBusy = false;
                            return;
                        }, () => {
                            this.IsBusy = false;
                            return;
                        }); // keep this line to prevent promise error;
                }
            }, () => {
                this.IsBusy = false;
                // this.IsBusy = false;
                return;
            })
            .catch(error => {
                this.sweetAlertService.swal(
                    {
                        title: 'Error',
                        text: error.message,
                        type: 'error',
                        showCancelButton: false,
                        showConfirmButton: true,
                        confirmButtonText: 'OK',
                    })
                    .then(() => {
                        this.IsBusy = false;
                        return;
                    }, () => {
                        this.IsBusy = false;
                        return;
                    }); // keep this line to prevent promise error;
            });

    }

    async refreshContent() {
        this.memberManagerIsBusy = true;
        await this.SearchMember(<any>this.MemberID);
        this.NavBarTitle = this.Dashboard.FirstName + ' ' + this.Dashboard.LastName; //  this.MemberID.toString();
        this.memberManagerIsBusy = false;
    }

    GetLatestOrder() {
        let newTab = window.open();

        //newTab.location.href = 'https://reports.structurestudios.com/order-form/v1/' + this.gb.ConvertToUrlFriendly(localStorage.getItem('crm_token')) + '/' + this.MemberID;
        //todo:  Update with live Reports URL before going live.
        //newTab.location.href = 'https://reports-api.structurestudios.com/Image/Members/OrderForm/' + this.gb.ConvertToUrlFriendly(localStorage.getItem('crm_token')) + '/' + this.MemberID;
        newTab.location.href = 'https://api-reports-ssdb3-node2.structurestudios.com/Image/Members/OrderForm/' + this.gb.ConvertToUrlFriendly(localStorage.getItem('crm_token')) + '/' + this.MemberID;
        
    }


    IsPinned(): boolean {
        return this.pinService.IsPinned(this.MemberID, PinTypes.Member);
    }

    RemovePin() {
        this.pinService.DeletePinByType(this.MemberID, PinTypes.Member);
    }

    AddPin() {
        let request = new PinAddRequest();
        request.AdminID = this.gb.AdminId;
        request.PinType = PinTypes.Member;
        request.RelationID = this.MemberID;
        this.pinService.Add(request);
    }

    TabChanged(e: any) {
        this.indexACTIVE = e.index;
        if (this.indexACTIVE == undefined)
            this.indexACTIVE = 0;
        this.LoadActiveTabData();
    }

    LoadActiveTabData(memberID: number = 0) {

        if (memberID == 0)
            memberID = this.Data.ID;

        this.NavBarTitle = this.Dashboard.FirstName + ' ' + this.Dashboard.LastName;

        switch (this.indexACTIVE) {

            case this.indexGIS:
                // GIS
                this.GetGISData();
                break;

            case this.indexCreditCards:
                // CreditCards
                this.CreditCards.Load();
                break;

            case this.indexNotes:
                // Notes
                this.Notes.LoadNotes(memberID);
                break;

            case this.indexEmail:
                // Email Panel
                this.GetEmailLogs();
                break;

            case this.indexActivity:
                // Activity Stream Panel
                this.LoadActivityStream();
                break;

            case this.indexLogs:
                // Logs Panel
                this.LoadMemberLogs();
                break;

            case this.indexTickets:
                // Tickets
                this.LoadTickets();
                break;

            case this.indexInvoices:
                this.LoadInvoices();
                break;

            case this.indexCredit:
                this.LoadCredits();
                break;

            case this.indexYardFiles:
                this.GetYardFiles();
                this.GetUploadedFiles();
                break;

            case this.indexTOS:
                this.TOS.getTOSSettings();
                this.TOS.GetAuditLogs();
                break;

            case this.indexTraining:
                this.LoadTrainingHistory();
                break;

            case this.indexOrphan:
                break;

            default:
                break;
        }
    }


    LoadActivityStream() {
        this.IsBusy = true;

        let disposable = this.api.GetMemberActivities(this.MemberID).subscribe(result => {
            disposable.unsubscribe();
            this.IsBusy = false;
            this.ActivityItems = result.Data;
        });

    }


    LoadTickets() {
        this.TicketsIsBusy = true;
        this.TicketWidgets = new CustomTicketItemArray();
        let subscription = this.api.GetCustomTicketsByMember(this.MemberID).subscribe(
            async (result: IBaseResponse<CustomTicketItemArray>) => {
                this.TicketsIsBusy = false;
                subscription.unsubscribe();

                if (!result.Result) {
                    this.IsBusy = false;
                    return;
                }

                this.TicketWidgets = result.Data;

                this.IsBusy = false;
            }, (error: any) => {
                subscription.unsubscribe();
                this.IsBusy = false;
            }
        );
    }

    LoadMemberLogs() {
        console.log("LML");
        this.MemberLogs = new LogsResponse();
        this.LogsIsBusy = true;
        let subscription = this.api.LogsByMemberID(this.MemberID).subscribe(
            async (result: IBaseResponse<LogsResponse>) => {
                subscription.unsubscribe();
                console.log("llr", result);
                if (!result.Result) {
                    this.LogsIsBusy = false;
                    return;
                }

                this.MemberLogs = result.Data;

                this.MemberLogs.AdminLogs = AdminLogItemArray.SortByDate(this.MemberLogs.AdminLogs);
                this.MemberLogs.MemberLogs = MemberLogItemArray.SortByDate(this.MemberLogs.MemberLogs);
                this.MemberLogs.AuthenticationLogs = AuthenticationLogItemArray.SortByDate(this.MemberLogs.AuthenticationLogs);


                this.LogsIsBusy = false;
            }, (error: any) => {
                subscription.unsubscribe();
                this.LogsIsBusy = false;
            }
        );
    }

    LoadTrainingHistory() {
        this.IsTrainingBusy = true;
        let disposable = this.api.GetTrainingHistoryForMember(this.MemberID).subscribe(response => {
            this.IsTrainingBusy = false;
            disposable.unsubscribe();
            this.TrainingHistory = response.Data;
        });
    }

    GetTimeDifferenceSeconds(fromDate: Date, toDate: Date): number {

        if (fromDate == null || toDate == null)
            return -1;

        return (fromDate.getTime() - toDate.getTime()) / 1000;
    }

    GetTimeDifferenceNowSeconds(toDate: Date): number {
        return this.GetTimeDifferenceSeconds(new Date(), toDate);
    }

    GetGISData() {

        // let LastLoadedDiff = this.GetTimeDifferenceNowSeconds(this.GISLastLoaded);
        // console.log("Difference last load: " + LastLoadedDiff);

        // if (LastLoadedDiff != -1 && LastLoadedDiff < this.GISLifetimeSeconds) {
        //   console.log("Don't load new data because LastLoaded " + LastLoadedDiff + " seconds < GISLifeTime " + this.GISLifetimeSeconds + " seconds");
        //   return;
        // }

        this.GISLastLoaded = new Date();
        this.GetGISUsageLog();
        this.GetGISBundleLog();

    }



    GetGISBundleLog() {

        this.GISBundleLogIsBusy = true;


        // let GISRequest = new ByDateRangeRequest(<any>this.MemberID);
        this.api.MemberGISBundleLog(this.MemberID).subscribe(

            (result: BaseResponse<GISBundleLogArray>) => {
                this.GISBundleLog = result.Data;
                this.GISBundleLogIsBusy = false;
                this.GISBundleLog = GISBundleLogArray.sortByPurchaseDate(this.GISBundleLog, sortDirection.Descending);
            },

            (error: any) => {
                xToastr.ShowToast(ToastrTypes.Error, error.FriendlyTitle, error.FriendlyMessage);
                this.GISBundleLogIsBusy = false;
            }


        );

    }

    LoadFiles() {
        this.GetYardFiles();
        this.GetUploadedFiles();
    }

    GetYardFiles() {
        this.IsFilesBusy = true;
        let disposable = this.api.GetMobileFilesByMemberID(this.MemberID).subscribe(response => {
            this.IsFilesBusy = false;
            if (response.Result) {
                this.YardFiles = response.Data;
            }
            disposable.unsubscribe();
        });
    }

    GetUploadedFiles() {
        this.IsFilesBusy = true;
        let disposable = this.api.FileUploadsByMember(this.MemberID).subscribe(response => {
            this.IsFilesBusy = false;
            if (response.Result) {
                var allFiles = response.Data;
                var uploadedFiles = new FileUploadItemArray();
                var uploadedLogs = new FileUploadItemArray();

                for (const item of allFiles) {
                    if (item.FileType === FileTypes.General){
                        uploadedFiles.push(item);
                    }
                    if (item.FileType === FileTypes.Logs){
                        uploadedLogs.push(item);
                    }
                }

                this.UploadedFiles = uploadedFiles;
                this.UploadedLogs = uploadedLogs;
            }
            disposable.unsubscribe();
        });
    }

    GetEmailLogs() {

        this.EmailLogsIsBusy = true;

        this.api.GetEmailLogs(this.MemberID).subscribe(

            (result: BaseResponse<EmailLogItemBasicArray>) => {
                this.EmailLogs = result.Data;
                if (this.EmailLogs != null) {
                    this.EmailLogs = EmailLogItemBasicArray.sortByDate(this.EmailLogs, sortDirection.Descending);
                }
                this.EmailLogsIsBusy = false;

            },

            (error: any) => {
                xToastr.ShowToast(ToastrTypes.Error, error.FriendlyTitle, error.FriendlyMessage);
                this.EmailLogsIsBusy = false;
            }

        );

    }

    GetGISUsageLog() {

        this.GISUsageLogIsBusy = true;

        // let GISRequest = new ByDateRangeRequest(<any>this.MemberID);
        // FIX IT!!!
        this.api.MemberGISUsageLog(this.MemberID).subscribe(

            (result: BaseResponse<GISUsageLogArray>) => {
                this.GISUsageLog = result.Data;
                this.GISUsageLog = GISUsageLogArray.sortByDate(this.GISUsageLog, sortDirection.Descending);
                this.GISUsageLogIsBusy = false;
            },

            (error: any) => {
                xToastr.ShowToast(ToastrTypes.Error, error.FriendlyTitle, error.FriendlyMessage);
                this.GISUsageLogIsBusy = false;
            }

        );
    }

    LoadInvoices() {
        this.InvoicesIsBusy = true;
        this.api.GetInvoices(this.MemberID.toString()).subscribe(

            (result: IBaseResponse<InvoiceArray>) => {

                if (!result.Result) {
                    // error
                    this.InvoicesIsBusy = false;
                    return;
                }

                if (result.Data == undefined || result.Data.length == 0) {
                    this.InvoicesIsBusy = false;
                    return;
                }

                this.Invoices = SortBot.SortAsc(result.Data, 'DateTimeCreated');
                console.log("INVOICES:", this.Invoices);

                this.InvoicesIsBusy = false;

            },

            (error: any) => {
                this.InvoicesIsBusy = false;
            }

        );
    }

    LoadCredits() {
        // this.refreshContent();
        this.CreditIsBusy = true;
        this.Credits = new CreditItemArray();
        this.api.GetCredit(this.MemberID.toString()).subscribe(

            (result: IBaseResponse<CreditItemArray>) => {

                if (!result.Result) {
                    // error

                    this.CreditIsBusy = false;
                    return;
                }

                if (result.Data == undefined || result.Data.length == 0) {
                    this.CreditIsBusy = false;
                    return;
                }


                this.Credits = result.Data;
                CreditItemArray.sortByDate(this.Credits, sortDirection.Descending);

                let total = 0;
                this.Credits.forEach(function(cred) {
                    total += cred.Amount;
                });

                if (total < 0)
                    total = 0;

                this.Dashboard.Credit = total;

                this.CreditIsBusy = false;
            },

            (error: any) => {
                this.CreditIsBusy = false;
            }

        );
    }

    Reset() {
        this.GISUsageLog = new GISUsageLogArray();
        this.GISBundleLog = new GISBundleLogArray();
        this.StickyNotes = new NoteArray();
        this.Invoices = new InvoiceArray();
    }

    SubscribeToLicenses(){
        //Subscribe to all licenses
        console.log("ownLicenses1", this.OwnLicenses);
        let ownLicenseKeys: Array<string> = this.OwnLicenses.map(license => license.Key);
        console.log("ownLicenses2", ownLicenseKeys);
        let designerLicenseKeys: Array<string> = this.DesignersLicenses.map(license => license.Key);
        let allLicenseKeys: Array<string> = ownLicenseKeys.concat(designerLicenseKeys);

        var request = new SubscribeToLicensesRequest();
        request.VerboseUpdates = true;
        request.LicenseKeys = allLicenseKeys;

        this.liveHub.InvokeConnection('SubscribeToLicenses', request);        

        //Handle responses
        this.connectionStatusSubscription = this.liveHub.LicenseConnectionStatusUpdate.subscribe(response => {
            //console.log("LCSUR", response);
            //Check to see if the member owns the license we're receiving an update for
            let memberLicense: MemberDashboardLicenseResponse | undefined = this.OwnLicenses.find(item => item.Key === response.LicenseKey);
            if (memberLicense) {
                if (response.IsConnected){
                    memberLicense.LiveHubConnectionStatus = LiveHubConnectionStatuses.Connected;
                }
                else{
                    memberLicense.LiveHubConnectionStatus = LiveHubConnectionStatuses.NotConnected;
                }
                memberLicense.LiveHubVersion = response.UpdaterVersion;
                memberLicense.LiveHubDateTimeConnectionStarted = new Date(response.DateTimeConnectionStarted);
                memberLicense.LiveHubDateTimeConnectionStopped = new Date(response.DateTimeConnectionStopped);                
            }
            //Didn't find it at the member level - check the designer licenses
            else{
                let designerLicense: MemberDashboardLicenseResponse | undefined = this.DesignersLicenses.find(item => item.Key === response.LicenseKey);
                if (designerLicense) {
                    if (response.IsConnected){
                        designerLicense.LiveHubConnectionStatus = LiveHubConnectionStatuses.Connected;
                    }
                    else{
                        designerLicense.LiveHubConnectionStatus = LiveHubConnectionStatuses.NotConnected;
                    }
                }
                console.log("respo", response);
                designerLicense.LiveHubVersion = response.UpdaterVersion;
                designerLicense.LiveHubDateTimeConnectionStarted = new Date(response.DateTimeConnectionStarted);
                designerLicense.LiveHubDateTimeConnectionStopped = new Date(response.DateTimeConnectionStopped);                       
            }
        })         

        this.updateSuccessSubscription = this.liveHub.UpdateSuccess.subscribe(response => {
            xToastr.ShowToast(ToastrTypes.Success, "Successful Software Update", "Updated to version " + response.FormattedVersionInt + "<br />Key: " +  response.LicenseKey);            
            let memberLicense: MemberDashboardLicenseResponse | undefined = this.OwnLicenses.find(item => item.Key === response.LicenseKey);
            if (memberLicense) {
                memberLicense.Version = response.FormattedVersionInt;
            }
            //Didn't find it at the member level - check the designer licenses
            else{
                let designerLicense: MemberDashboardLicenseResponse | undefined = this.DesignersLicenses.find(item => item.Key === response.LicenseKey);
                if (designerLicense) {
                    designerLicense.Version = response.FormattedVersionInt;
                }
            }            
        })
    }

    async SearchMember(id: number) {

        this.Reset();
        await this.api.getMemberDashboard(<any>id).toPromise().then(

            (result) => {

				console.log("getMemberDashboard(1) result :", result);

                if (!result.Result) {
                    this.sweetAlertService.swal({
                        type: 'error',
                        title: 'Error',
                        text: result.Message
                    }).then(() => {
                        this.location.back();
                    }, () => {
                        this.location.back();
                    });
                    return;
                }

                this.IsBusy = false;

                this.Dashboard = result.Data;

                this.gb.SetPageTitle(result.Data.FirstName + ' ' + result.Data.LastName);

                this.StickyNotes = this.Dashboard.StickyNotes;

                this.TabChanged(this.indexSoftwareLicense);


                if (this.Dashboard.OwnLicenses != undefined)
                    this.OwnLicenses = MemberDashboardLicenseResponseArray.initVariables(this.Dashboard.OwnLicenses);
                else
                    this.OwnLicenses = MemberDashboardLicenseResponseArray.initVariables(new MemberDashboardLicenseResponseArray());

                if (this.Dashboard.DesignersLicenses != undefined)
                    this.DesignersLicenses = MemberDashboardLicenseResponseArray.initVariables(this.Dashboard.DesignersLicenses);
                else
                    this.DesignersLicenses = MemberDashboardLicenseResponseArray.initVariables(new MemberDashboardLicenseResponseArray());

                //Subscribe to licenses
                this.SubscribeToLicenses();

            })
            .catch(
                (error: any) => {

                }


            );
    }




    AddToStickyNotes(notes: NoteArray) {
        if (this.StickyNotes == null)
            this.StickyNotes = new NoteArray();

        notes.forEach((note) => {
            let index = this.StickyNotes.findIndex(x => x.ID == note.ID);
            if (index == -1)
                this.StickyNotes.push(note);

        });

    }

    AddMemberNote() {

        let type = new KeyValuePair<NoteTypes, number>(NoteTypes.Member, this.MemberID);

        let noteData = new NoteManagerConstructor();
        noteData.MemberID = this.MemberID;
        noteData.HasReviewed = this.Dashboard.HasReviewed;
        noteData.NoteType = type;
        noteData.RelationObject = this.Dashboard; // this.Member;
        noteData.IsAddNote = true;
        noteData.RelationInfo = this.Dashboard.FirstName + ' ' + this.Dashboard.LastName;
        this.ShowNoteDialog(noteData);

    }

    ShowNoteDialog(noteData: NoteManagerConstructor) {
        let note = new NoteManager(noteData);
        let options: DialogOptions = {
            dialogWindowType: DialogWindowTypes.Window,
            width: 1240,
            height: 650
        };
        let disposable = this.dialogService.addDialog(NoteDetailsDialog, { noteManager: note }, options).subscribe(response => {
            disposable.unsubscribe();
        });
    }

    ShowNoteWindow(noteData: NoteManagerConstructor) {
        let windowSettings = new WindowSettings();
        windowSettings.Height = 600;
        windowSettings.Width = 1240;

        let result = this.windowService.OpenWindow<NoteManagerConstructor>(WindowTypes.Note, noteData, windowSettings);

        let subscription = result.onEvent.subscribe(event => {

            if (event.ActionType == WindowActionTypes.Saved) {
                // this.onNoteChanged( event.Data );
                this.Notes.LoadNotes(this.MemberID);
            }

            if (event.ActionType == WindowActionTypes.Close)
                subscription.unsubscribe();

        });
    }

    UpdateStickyNotes(note: NoteChangeResult) {
        if (this.StickyNotes == null)
            this.StickyNotes = new NoteArray();

        if (note.New.Sticky) {
            let index = this.StickyNotes.findIndex(x => x.ID == note.New.ID);
            if (index == -1)
                this.StickyNotes.push(note.New);
            else
                this.StickyNotes[index] = note.New;
        } else {
            this.StickyNotes.forEach(x => {
                let index = this.StickyNotes.findIndex(y => y.ID == note.New.ID);
                if (index != -1)
                    this.StickyNotes.splice(index, 1);
            });
        }
    }


    PopulateData(data: MemberDashboard) {
        console.log("Populating Data");
        this.Data = data;

        this.titleService.setTitle(this.Data.FirstName + ' ' + this.Data.LastName);
        // this.Credits = 0 ;// data.Credits;
        // this.CreditAmount = data.CreditAmount;

        this.gb.LastMemberID = data.ID;
        this.gb.LastMemberFullName = data.FirstName + ' ' + data.LastName;

        // Active Tab data
        this.LoadActiveTabData(data.ID);

        // sticky notes
        this.AddToStickyNotes(data.StickyNotes);

        // ProfileOverview
        this.ProfileOverview.SetTags(data.Tags);

        // member/designer
        if (data.IsDesigner) {
            // we are a designer

            this.NavBarTitle = 'Designer Profile';
            this.DesignersLicenses = new MemberDashboardLicenseResponseArray();
            this.OwnLicenses = data.OwnLicenses;

        } else {
            // we are a member with possible designers

            this.NavBarTitle = 'Member Profile';
            this.OwnLicenses = data.OwnLicenses;

            let licenses = new MemberDashboardLicenseResponseArray();

            // add all designer licenses to designerlicenses array
            if (data.DesignersLicenses != null) {

                data.DesignersLicenses.forEach(license => {
                    licenses.push(license);
                });

            }

            this.DesignersLicenses = licenses;
        }
    }


    showMergeMember() {
        let options = {
            width: 1000
        };
        let disposable = this.dialogService.addDialog(MergeProfilesDialog, {
			title: '', subTitle: '', message: '',
			MemberID: this.MemberID,
        }, options).subscribe(response => {
            disposable.unsubscribe();
            if (response) {
                window.location.reload();
            }
        }, error => {
            disposable.unsubscribe();
        });
    }

    TransferToMember() {
        let disposable = this.dialogService.addDialog(TransferMemberDialog, {
            title: 'Transfer Member',
            MemberID: this.MemberID
        }).subscribe(response => {
            disposable.unsubscribe();
        });
    }

    DetachDesigner() {
        this.sweetAlertService.swal({
            type: 'warning',
            title: 'Are you sure?',
            text: 'This will detach this designer from the parent member and cannot be undone.',
            showCancelButton: true,
            preConfirm: () => {
                let request: ForceChildToMemberRequest = {
                    ChildMemberID: this.Dashboard.ID,
                    NewParentMemberID: 17
                };

                return this.api.ForceChildToMember(request).toPromise();
            }
        }).then((response) => {
            if (response.Result) {
                this.sweetAlertService.swal({
                    type: 'success',
                    title: 'Member Orphaned',
                    text: 'This member has now been orphaned and the page will reload',
                    timer: 1500
                }).then(() => { window.location.reload(); }, () => { window.location.reload(); });
            } else {
                this.sweetAlertService.swal({
                    type: 'error',
                    title: 'Member Not Orphaned',
                    text: 'An error occured and this member could not be orphaned'
                }).then(() => { }, () => { });

            }
        }, () => { });
    }

    TransformToMember() {
        this.sweetAlertService.swal({
            type: 'warning',
            title: 'Are you sure?',
            text: 'This will transform the designer to a member and bring along his keys. At least one active, non-expired credit card must exist on the designers profile.',
            showCancelButton: true,
            preConfirm: () => {
                let request: TransformDesignerToMemberRequest = {
                    DesignerID: this.Dashboard.ID
                };
                return this.api.TransformDesignerToMember(request).toPromise();
            }
        }).then((response) => {
            if (response.Result) {
                this.sweetAlertService.swal({
                    type: 'success',
                    title: 'Designer is now a Member',
                    text: 'This designer has been transformed into a new member. The page will now reload.',
                    timer: 1500
                }).then(() => { window.location.reload(); }, () => { window.location.reload(); });
            } else {
                this.sweetAlertService.swal({
                    type: 'error',
                    title: 'Designer Not Converted',
                    text: 'An error occured and this designer could not be transformed.'
                }).then(() => { }, () => { });

            }
        }, () => { });
    }

    async deleteMember() {
        this.IsBusy = true;

        if (this.Dashboard.MemberType == 100) {
            await this.sweetAlertService.swal({
                type: 'error',
                title: 'Cannot Delete',
                text: 'Cannot delete an active member.'
            }).then(() => { this.IsBusy = false; });
        } else {
            await this.sweetAlertService.swal({
                title: 'Delete Member?',
                text: 'Are you sure you want to delete this member?',
                type: 'warning',
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Yes!',
                cancelButtonText: 'Cancel',
                allowOutsideClick: false,
            }).then(async response => {
                this.IsBusy = false;
                await this.api.MemberDelete(this.MemberID).subscribe(response => {
                    if (response.Result) {
                        this.sweetAlertService.swal(
                            {
                                title: 'Success!',
                                text: 'Member Deleted',
                                type: 'success',
                                showCancelButton: false,
                                showConfirmButton: false,
                                timer: 1500
                            }).then(() => {
                                this.location.back();
                                this.IsBusy = false;
                            }, () => {
                                this.location.back();
                                this.IsBusy = false;
                                return;
                            }); // keep this line to prevent promise error;
                    } else {
                        this.sweetAlertService.swal(
                            {
                                title: 'ERROR!',
                                text: 'Message: ' + response.Data,
                                type: 'error',
                                showCancelButton: false,
                                showConfirmButton: true,
                                confirmButtonText: 'OK'
                            }).then(() => {
                                this.IsBusy = false;
                            }, () => {
                                this.IsBusy = false;
                                return;
                            }); // keep this line to prevent promise error;
                    }
                }, error => {
                    this.sweetAlertService.swal(
                        {
                            title: 'ERROR!',
                            text: 'Message: ' + error,
                            type: 'error',
                            showCancelButton: false,
                            showConfirmButton: true,
                            confirmButtonText: 'OK'
                        }).then(() => {
                            this.IsBusy = false;
                        }, () => {
                            this.IsBusy = false;
                            return;
                        }); // keep this line to prevent promise error;
                });
            }, () => {
                this.IsBusy = false;
            });
        }
    }


    async TagsChangedCatch(e: MemberTagsEditRequest) {
        // this.TagsChanged.emit( e );
        if (e.TagItemIDs != undefined && e.TagItemIDs.length > 0) {
            if (this.AvailableTags == undefined) {
                this.AvailableTags = await this.api.getAvailableTags().toPromise().then(response => {
                    return response.Data;
                }).catch(error => {
                    return new TagArray;
                });
            }
            let isTOSCount: number = 0;
            let hasReviewedCount: number = 0;
            this.AvailableTags.forEach(y => {
                if (y.TagTOSType == TagTOSTypes.TOS) {
                    e.TagItemIDs.forEach(x => {
                        if (y.ID == x)
                            isTOSCount += 1;

                        
                    });
                }
                if (y.TagTOSType == TagTOSTypes.HasReviewed) {
                    e.TagItemIDs.forEach(x => {
                        if (y.ID == x)
                        hasReviewedCount += 1;

                        
                    });
                }

            });
            if (isTOSCount > 0)
                this.Dashboard.IsTOS = true;
            else
                this.Dashboard.IsTOS = false;

            if (hasReviewedCount > 0)
                this.Dashboard.HasReviewed = true;
            else
                this.Dashboard.HasReviewed = false;

        } else {
            this.Dashboard.IsTOS = false;
            this.Dashboard.HasReviewed = false;
        }
    }

    MemberChangedCatch(e: MemberTagsEditRequest) {
        this.SearchMember(<any>this.MemberID);
    }

    GetAvailableTags() {
        let disposable = this.api.getAvailableTags().subscribe(result => {
            disposable.unsubscribe();
            this.AvailableTags = result.Data;
        }, error => {
            disposable.unsubscribe();
        });
    }


    LogInAsMemberClick() {
        let disposable = this.dialogService.addDialog(AddNotePromptDialog, {
            MemberID: this.MemberID,
            showCancel: true,
            title: 'Log In As Member Reason', subTitle: '', message: '',
            noteTemplate: 'Login As Member',
			okText: 'Log In As Member',
			okLinkURL: '',
            showServerButtons: true
        }, {
                width: 400,
                height: 500,
                IsRequired: true
            }).subscribe(response => {
                disposable.unsubscribe();
                if (response != 'cancel' && response != '') {
                    // Parse server and note from response (format: "server::note")
                    const separatorIndex = response.indexOf('::');
                    const server = response.substring(0, separatorIndex) as 'live' | 'dev';
                    const note = response.substring(separatorIndex + 2);
                    this.logInAsMember(note, server);
                }
            }, error => {
                disposable.unsubscribe();
            });
    }

    logInAsMember(note: string = '', server: 'live' | 'dev' = 'live') {
        let request: MemberNewLoginSessionRequest = new MemberNewLoginSessionRequest;
        request.MemberID = this.MemberID;
        request.Note = note;

        let newTab = window.open();

        let disposable = this.api.GetMemberNewLoginSession(request).subscribe(response => {
            disposable.unsubscribe();
            if (!response.Result) {
                this.ErrorLoggingInAsMember(response.Message);
                newTab.close();
                return;
            }

            const baseUrl = server === 'dev'
                ? 'https://members-dev-react.structurestudios.com'
                : 'https://members.structurestudios.com';

            newTab.location.href = baseUrl + '/login-as-member/' + response.Data.toString() + '/' + this.gb.AdminId;

        }, error => {
            disposable.unsubscribe();
        });

    }

    ErrorLoggingInAsMember(errorMessage: string) {
        this.sweetAlertService.swal(
            {
                title: 'Error',
                text: errorMessage,
                type: 'error',
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonText: 'OK',
            })
            .then(() => {
                this.IsBusy = false;
                return;
            }, () => {
                this.IsBusy = false;
                return;
            }); // keep this line to prevent promise error;
    }

    showTestDialog() {

        let windowSettings = new WindowSettings();
        windowSettings.Height = 900;
        windowSettings.Width = 1240;

        let result = this.windowService.OpenWindow<string>(WindowTypes.License, 'B3BA5-3KDD7-KB49C', windowSettings);

        let subscription = result.onEvent.subscribe(event => {

            if (event.ActionType == WindowActionTypes.Close)
                subscription.unsubscribe();

        });

    }

    GetFullName(): string {
        return this.Dashboard.FirstName + ' ' + this.Dashboard.LastName;
    }

    IsDesigner() {
        switch (this.Dashboard.MemberType) {
            case 100:
            case 110:
                return false;
            case 200:
            case 210:
            case 220:
                return true;
        }
    }

    ColorForTickets(): string {
        if (this.Dashboard.OpenTickets > 0) {
            return '#ffc8c8';
        } else {
            if (this.indexACTIVE == 8) {
                return '#fff';
            } else {
                return 'transparent';
            }
        }
    }

}
